import styled, { css } from 'styled-components';
import { spacer4, spacer16 } from '@spotify-internal/encore-foundation';
import IconChartDown from "../Icon/IconChartDown";
export default styled(IconChartDown).attrs(function (props) {
  return {
    'aria-label': props.direction === 'up' ? 'Sort column (ascending)' : 'Sort column (descending)'
  };
}).withConfig({
  displayName: "TableSortIcon",
  componentId: "cu4kvx-0"
})(["height:", ";width:", ";margin:-", " ", ";", ";"], spacer16, spacer16, spacer4, spacer4, function (props) {
  return props.direction === 'up' && css(["transform:rotate(180deg);margin-bottom:-5px;"]);
});